import _ from "lodash";
import {
  Component,
} from "react";
import {
  Spinner, Panel,
} from "CommonComponents/bricks";
import antragApi from "Apis/antrag-api";
import apifetch from "CommonCore/apifetch";
import {
  Table,
} from "react-bootstrap";
import {
  getPathComponent,
} from "CommonCore/location-util";
import {
  formatDate,
} from "CommonCore/l10n";
import {
  withLocation,
} from "CommonCore/router-util";

@withLocation
@antragApi.current
export default class AntragVerträgeTab extends Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount = async() => {
    const a_id = getPathComponent(this.props.location, 2);
    if (a_id) {
      let vertraege;
      try {
        vertraege = await apifetch(`/api/shkimport/personmassnahme/${ a_id }`);
      } catch(err) {
          // Verbindung zu PBP nicht vorhanden oder niemand gefunden
      }
      vertraege = vertraege && vertraege.data;

      if (vertraege) {
        vertraege = _.sortBy(vertraege, x => x.von);
        this.setState({ vertraege });
      } else {
        this.setState({ vertraege: [] });
      }
    }
  };

  render() {
    const { vertraege } = this.state;

    if (!vertraege) {
      return <Spinner />;
    }

    return <div className='detail-form'><Panel>
      In der folgenden Tabelle werden die Arbeitszeiten aufgelistet, die in PBP bereits zur diesem Antrag zugeordneten Person bekannt sind:
    </Panel>

    <Table striped>
      <thead>
        <tr><th>Zuordnung</th>
          <th>Art</th>
          <th>Gültig von</th>
          <th>Gültig bis</th>
          <th>Anzahl Stunden</th>
        </tr>
      </thead>
      <tbody>
        {_.map(vertraege, (v, i) => {
          return <tr key={i}><td>{v.typ}</td><td>{v.art}</td><td>{formatDate(v.von)}</td><td>{formatDate(v.bis)}</td><td>{v.stunden}</td></tr>;
        })}

        {_.isEmpty(vertraege) && <tr><td colSpan={4} style={{ textAlign: "center" }}><h4>Keine weiteren Arbeitszeiten gefunden</h4></td></tr>}

      </tbody>

    </Table></div>;
  }
}
